import React from 'react'
import styled from 'styled-components'

const EduEmp = ({item}) => {
  return (
    <Wrapper>
        <div className='block-container'>
        <div className='block'>
        <p className='institution'>{item.degree}</p>
        <p className='degree'>{item.college}</p>
        <p className='period'>{item.period} <span className='span'>{item.percentage}</span></p>
    
        </div>
        </div>
      
  
    </Wrapper>

  )
}

const Wrapper =  styled.section`
/* width: 80%;
margin: auto; */

p{
  /* background-color: aqua; */
  margin: 0;
}
.span {
  /* font-weight: bold; */
  /* color: blueviolet; */
  font-size: small;
  margin-left: 1rem;
}
.institution{
  
  font-size: large;
  color:  #D40B7E;;

}
.period{
  font-size: small;
}
.degree{
  font-size: small;
  color: #2B86C5;
}

/* margin-left: 20px; */
.block-container{
  position: relative;
  /* width: 80%; */
  /* background-color: red; */
  /* margin: auto;s */
  border-left: 2px solid #D40B7E;

}

.block{
  margin-left: 2rem;
  padding-bottom: 1rem;
  /* background-color: aqua; */
 

}


/* background-color: red; */
/*  */

`

export default EduEmp